var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fullscreen",
    {
      ref: "fullscreen",
      staticClass: "fullscreen",
      on: { change: _vm.fullscreenChange }
    },
    [
      _c(
        "button",
        {
          staticClass: "button-adjust",
          attrs: { type: "button" },
          on: { click: _vm.toggle }
        },
        [_c("i", { class: _vm.buttonClass })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagecenter" }, [
        _c("div", { staticClass: "pagecenterdetails" }, [
          _c("div", { staticClass: "logo" }, [
            _c("img", {
              attrs: {
                src: "static/images/logo111.png",
                alt: "Velocity Vehicle Group"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "number" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isClosed,
                    expression: "!isClosed"
                  }
                ],
                staticClass: "numberdetails"
              },
              [
                _vm.isWillCall ? _c("span", [_vm._v("WILL CALL")]) : _vm._e(),
                _vm._v(" "),
                !_vm.isWillCall
                  ? _c("span", [_vm._v("Front Counter")])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.closedTicketNumber))]),
                _vm._v(" "),
                _c("span", [_vm._v("NOW SERVING")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isClosed,
                    expression: "isClosed"
                  }
                ],
                staticClass: "numberdetails"
              },
              [
                _c("img", {
                  attrs: {
                    src: "static/images/closed.png",
                    alt: "Velocity Vehicle Group"
                  }
                })
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e578740", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e578740","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentClosedTickets.vue
// module id = null
// module chunks = 